var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPropertyType = function SvgPropertyType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.6,
    height: 1.2,
    x: 10.2,
    y: 10.8,
    fill: "currentColor",
    rx: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.6,
    height: 1.2,
    x: 10.2,
    y: 13.8,
    fill: "currentColor",
    rx: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.6,
    height: 1.2,
    x: 10.2,
    y: 16.8,
    fill: "currentColor",
    rx: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 1.2,
    x: 7.2,
    y: 10.8,
    fill: "currentColor",
    rx: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 1.2,
    x: 7.2,
    y: 13.8,
    fill: "currentColor",
    rx: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 1.2,
    x: 7.2,
    y: 16.8,
    fill: "currentColor",
    rx: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M20.16 21.6H3.84a.24.24 0 0 1-.24-.24V9.473a.24.24 0 0 1 .087-.185l8.16-6.761a.24.24 0 0 1 .306 0l8.16 6.76a.24.24 0 0 1 .087.186V21.36a.24.24 0 0 1-.24.24Z"
  })));
};
export default SvgPropertyType;